import React, { useContext, useEffect, useReducer } from "react";
import { 
    Box, Grid, TextField, Typography, Button, Divider, 
    useTheme, useMediaQuery, Container, CssBaseline 
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { LoadingButton } from "@mui/lab";

// Logos
import logo from '../../assets/images/logos/black.png';

// Auth y Controladores
import AuthContext from "../../navigation/context/authContext";
import { gapi } from 'gapi-script';
import SocialAuth from "./SocialAuth";
import ReCaptchaGoogle from "../../components/ReCaptchaGoogle";

// ESTADOS INICIALES
const initialState = {
    email: '', errorEmail: false,
    password: '', errorPassword: false,
    isLoading: false,
    reCaptcha: ''
};
  
function reducer(state, { field, value }) {
    return { ...state, [field]: value };
}
  
export default function SignIn() {
    const theme = useTheme();
    const history = useHistory();
    const { signIn } = useContext(AuthContext);
    const [state, setState] = useReducer(reducer, initialState);

    const { email, errorEmail, password, errorPassword, isLoading, reCaptcha } = state;

    useEffect(() => {
        window.scrollTo(0,0);
        function start() {
            gapi.client.init({
              clientId: '617727461618-03sc7bftdp5bmh6cnjeftp23nuf5ad6i.apps.googleusercontent.com',
              scope: 'email',
            });
        }
        gapi.load('client:auth2', start);
    }, []);

    const onChange = (e) => {
        setState({ field: e.target.name, value: e.target.value });
    };

    const redirect = (route) => {
        history.push(route);
    };

    const formVerification = () => {
        let ban = 0;
        if (email === '') { setState({ field: 'errorEmail', value: true }); ban = 1; }
        if (password === '') { setState({ field: 'errorPassword', value: true }); ban = 1; }
        return ban;
    };

    const handleSubmit = async () => {
        setState({ field: 'isLoading', value: true });
        if (formVerification() === 0) {
            await signIn({ email, password });
        }
        setState({ field: 'isLoading', value: false });
    };

    const handleOnChangeRecaptcha = (value) => {
        setState({ field: 'reCaptcha', value: value });
    };

    const handleOnExpiredRecaptcha = () => {
        setState({ field: 'reCaptcha', value: '' });
    };

    return (
        <Box sx={{ 
            minHeight: '100vh', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center', 
            alignItems: 'center',
            bgcolor: '#ffffff', // Fondo blanco puro para minimalismo total
            p: 3
        }}>
            <CssBaseline />
            
            <Container maxWidth="xs" disableGutters>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                    
                    {/* --- LOGO --- 
                    <Box sx={{ mb: 4 }}>
                        <img src={logo} alt="QUD Logo" style={{ width: 85, height: 'auto' }} />
                    </Box>*/}

                    {/* --- TÍTULO Y SUBTÍTULO --- */}
                    <Typography variant="h4" fontWeight="800" color="#111" textAlign="center" gutterBottom sx={{ fontSize: { xs: '1.75rem', sm: '2rem' } }}>
                        Inicia sesión en QUD
                    </Typography>
                    <Typography variant="body1" color="text.secondary" textAlign="center" mb={6}>
                        Ingresa tus credenciales para acceder a tu panel.
                    </Typography>

                    {/* --- FORMULARIO PRINCIPAL --- */}
                    <Box component="form" noValidate sx={{ width: '100%' }}>
                        
                        {/* Campo Email */}
                        <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8} sx={{ letterSpacing: 0.3 }}>
                            Correo Electrónico
                        </Typography>
                        <TextField
                            fullWidth
                            id="email"
                            name="email"
                            placeholder="ejemplo@empresa.com"
                            variant="outlined"
                            autoComplete="email"
                            autoFocus
                            value={email}
                            onChange={onChange}
                            onBlur={() => setState({ field: 'errorEmail', value: email === '' })}
                            error={errorEmail}
                            helperText={errorEmail && 'El correo es requerido'}
                            sx={{ mb: 3.5, '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                        />

                        {/* Campo Contraseña */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.8 }}>
                            <Typography variant="subtitle2" fontWeight="700" color="#333" sx={{ letterSpacing: 0.3 }}>
                                Contraseña
                            </Typography>
                            {/* Olvidé mi contraseña */}
                            <Button 
                                onClick={() => redirect('/auth/forgotPassword')}
                                sx={{ textTransform: 'none', fontWeight: 'bold', fontSize: '0.8rem', color: 'primary.main', p: 0, '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' } }}
                            >
                                ¿Olvidaste tu contraseña?
                            </Button>
                        </Box>
                        <TextField
                            fullWidth
                            id="password"
                            name="password"
                            placeholder="••••••••"
                            type="password"
                            variant="outlined"
                            autoComplete="current-password"
                            value={password}
                            onChange={onChange}
                            onBlur={() => setState({ field: 'errorPassword', value: password === '' })}
                            error={errorPassword}
                            helperText={errorPassword && 'La contraseña es requerida'}
                            sx={{ mb: 3.5, '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                        />

                        {/* ReCaptcha (Centrado) */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3.5 }}>
                            <ReCaptchaGoogle
                                onChange={handleOnChangeRecaptcha}
                                onAbort={handleOnExpiredRecaptcha}
                                onExpired={handleOnExpiredRecaptcha}
                            />
                        </Box>

                        {/* Botón de Submit (Grande e Imponente) */}
                        <LoadingButton
                            fullWidth
                            disabled={reCaptcha === ''}
                            variant="contained"
                            size="large"
                            loading={isLoading}
                            onClick={handleSubmit}
                            disableElevation
                            sx={{ py: 1.8, fontSize: '1rem', fontWeight: '800', borderRadius: 3, mb: 4, textTransform: 'none' }}
                        >
                            Iniciar Sesión en QUD
                        </LoadingButton>

                        {/* Separador OR Minimalista */}
                        <Divider sx={{ mb: 4, color: '#aaa', fontSize: '0.8rem', fontWeight: 600, '&::before, &::after': { borderColor: '#eeeeee' } }}>
                            O continúa con
                        </Divider>

                        {/* Social Auth (Google, etc.) */}
                        <Box sx={{ mb: 5 }}>
                            <SocialAuth />
                        </Box>
                        
                        {/* Registro */}
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography variant="body2" color="text.secondary">
                                ¿Eres nuevo?{' '}
                                <Button 
                                    onClick={() => redirect('/auth/userType')}
                                    sx={{ textTransform: 'none', fontWeight: '800', color: 'primary.main', p: 0, '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' } }}
                                >
                                    Regístrate
                                </Button>
                            </Typography>
                        </Box>  
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}